<template>
  <p v-if="html" :style="labelStyle" v-sanitized-html="sanitizedHtml"></p>
  <p v-else :style="labelStyle"><slot></slot></p>
</template>

<script setup lang="ts">
import type { ICSSProperties, IViewDimension } from "@/stores/types";
import { computed, onBeforeMount, onMounted } from "vue";
import { sanitizeHtml } from "@/utils/sanitizeHtml";

export interface IVLabelProps {
  weight?: "regular" | "heavy" | "light" | "regular-2";
  color?: string;
  size?: string;
  dimension?: IViewDimension;
  flex?: string;
  width?: string;
  fontStyle?: string;
  textAlign?: ICSSProperties["textAlign"];
  whiteSpace?: string;
  overflow?: string;
  textOverflow?: string;
  html?: string;
}

const props = defineProps<IVLabelProps>();
const sanitizedHtml = computed(() => sanitizeHtml(props.html));

const propsToCSSMap = {
  fontWeight: {
    heavy: "var(--font-weight-bold)",
    regular: "var(--font-weight-regular)",
    "regular-2": "var(--font-weight-medium)",
    light: "var(--font-weight-regular)",
  },
};
const labelStyle = computed<ICSSProperties>(() => {
  const fontWeight = props.weight || "regular";
  // console.log('v-label', 'labelStyle', fontWeight, props)
  return {
    margin: props.dimension?.margin || "unset",
    padding: props.dimension?.padding || "unset",
    fontWeight: propsToCSSMap.fontWeight[fontWeight],
    fontSize: props.size || "var(--font-size-body)",
    color: props.color,
    flex: props.flex,
    width: props.width,
    fontStyle: props.fontStyle,
    textAlign: props.textAlign,
    wordBreak: "break-word",
    whiteSpace: props.whiteSpace || "unset",
    overflow: props.overflow,
    textOverflow: props.textOverflow,
  };
});
onBeforeMount(() => {
  // console.log('vlabel', 'before mount', props.weight)
});

onMounted(() => {
  // console.log('vlabel', 'mount', props.weight)
});
</script>
